import { useUserStore } from '@/stores/user'

function redirectIfNotVector() {
  const user = useUserStore()
  if (user.data?.access?.vector !== true)
    window.location.href = import.meta.env.VITE_APP_URL
}

const ssdi = [
  {
    path: '/vector/ssdi',
    name: 'vector-ssdi-call-list',
    component: () => import('@/pages/vector/ssdi/index.vue'),
    meta: {
      title: 'SSDI Call List',
      resource: 'Vector',
      action: 'read',
      subject: 'Case',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/ssdi/reconciliation-import',
    name: 'vector-ssdi-reconciliation-import',
    component: () => import('@/pages/vector/ssdi/reconciliation-import.vue'),
    meta: {
      title: 'SSDI Reconciliation Import',
      resource: 'Vector',
      action: 'read',
      subject: 'Case',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/ssdi/opportunities/:opportunity_uuid/form',
    name: 'vector-ssdi-opportunity-form',
    component: () => import('@/pages/vector/ssdi/OpportunityForm.vue'),
    meta: { title: 'SSDI Qualification Form', resource: 'Vector' },
    beforeEnter() { redirectIfNotVector() },
  },
  {
    path: '/vector/ssdi/opportunities/:opportunity_uuid',
    name: 'vector-ssdi-opportunity-detail',
    component: () => import('@/pages/vector/ssdi/OpportunityDetail.vue'),
    meta: { title: 'SSDI Opportunity', resource: 'Vector', action: 'read', subject: 'Case' },
    beforeEnter() { redirectIfNotVector() },
  },
  {
    path: '/vector/ssdi/opportunities/:opportunity_uuid/workflow',
    name: 'vector-ssdi-workflow',
    component: () => import('@/pages/vector/ssdi/WorkflowPage.vue'),
    meta: { title: 'SSDI Call Workflow', resource: 'Vector', action: 'read', subject: 'Case' },
    beforeEnter() { redirectIfNotVector() },
  },
]

export default ssdi
